import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import { Iconstant } from 'src/app/core/constants/constant';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { MaterialModule } from 'src/app/material.module';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { PropertyAddComponent } from 'src/app/shared/pages/property-management/property-add/property-add.component';
import { PropertyDetailComponent } from 'src/app/shared/pages/property-management/property-detail/property-detail.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AfterViewInit, ViewChild } from '@angular/core';
import { UserVideosDialogComponent } from './user-videos-dialog.component';
import { ToastService } from 'src/app/shared/services/toast.service';

// const ELEMENT_DATA: PeriodicElement[] = [
//   { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'Active' },
//   { position: 2, name: 'Helium', weight: 4.0026, symbol: 'Active' },
//   { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Active' },
//   { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Active' },
//   { position: 5, name: 'Boron', weight: 10.811, symbol: 'Active' },
//   { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'Active' },
//   { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'Active' },
//   { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'Active' },
//   { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'Active' },
//   { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Active' },
// ];

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [MaterialModule, CommonModule, FormsModule],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements AfterViewInit {
  displayedColumns: string[] = ['fullName', 'email', 'totalVideos', 'totalPunches', 'status', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  searchQuery: string = '';
  statusFilter: string = '';
  constant: any = Iconstant;
  userList: any = [];
  totalRecords = 0;
  pageIndex = 0; // 0-based for MatPaginator
  pageSize = 10;
 sorts: any[] = [
  { value: 'active', viewValue: 'Active' },
  { value: 'inactive', viewValue: 'inactive' },
];


  private searchTerms = new Subject<string>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private userManagementService: UserManagementService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.getUserList();
    this.getUserListBySearch();
    console.log(this.dataSource)

  }

  ngAfterViewInit(): void {
    // Attach paginator once available
    this.dataSource.paginator = this.paginator;
  }

  onChange(event: any) {
  this.statusFilter = event.value || '';
  this.pageIndex = 0;
  const hasSearch = this.searchQuery && this.searchQuery.trim().length > 0;
  const obs = hasSearch
    ? this.userManagementService.getUserListBySearchQueryPaginated(this.searchQuery, this.pageIndex + 1, this.pageSize, this.statusFilter)
    : this.userManagementService.getUserListPaginated(this.pageIndex + 1, this.pageSize, this.statusFilter);
  obs.subscribe((res: any) => {
    if (res.isSuccess) {
      this.dataSource.data = res.items;
      this.userList = res.items;
      this.totalRecords = (res.totalRecords ?? res.total ?? res.count ?? (res.items?.length || 0));
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
        this.paginator.firstPage();
      }
    }
  }, (error: any) => {
    console.log(error);
  });
}

  changeProfileStatus(detail: any, status: any) {
    console.log('detail', detail)
    const body = {
      status: status
    }
    this.userManagementService.changeUserStatusById(detail.id, body).subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          // this.getUserList();
          const user = this.dataSource.data.find((item: any) => item.id === detail.id);
          if (user) {
            user.status = status;
          }
        }
      },
      error: (error: any) => { }
    })
  }


  getUserListBySearch() {
    this.searchTerms.pipe(
      debounceTime(500),               // wait 300ms after each keystroke
      distinctUntilChanged(),          // ignore if next search term is same as previous
      switchMap(term => {
        // reset to first page on new term
        this.pageIndex = 0;
        this.searchQuery = term || '';
        if (this.searchQuery && this.searchQuery.trim().length > 0) {
          return this.userManagementService.getUserListBySearchQueryPaginated(this.searchQuery, this.pageIndex + 1, this.pageSize, this.statusFilter)
        } else {
          return this.userManagementService.getUserListPaginated(this.pageIndex + 1, this.pageSize, this.statusFilter);
        }
      })
    ).subscribe((res: any) => {
      if (res.isSuccess) {
        this.dataSource.data = res.items;
        this.userList = res.items;
        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
          this.paginator.firstPage();
        }
        this.totalRecords = (res.totalRecords ?? res.total ?? res.count ?? (res.items?.length || 0));
      }
    }, (error: any) => {
      console.log(error)
    }
    )
  }

  search(event: any) {
    const query = event.target.value;
    this.pageIndex = 0;
    this.searchTerms.next(query);
  }


  getUserList() {
    this.userManagementService.getUserListPaginated(this.pageIndex + 1, this.pageSize, this.statusFilter).subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          this.dataSource.data = res.items;
          this.userList = res.items;
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
            this.paginator.firstPage();
          }
          this.totalRecords = (res.totalRecords ?? res.total ?? res.count ?? (res.items?.length || 0));
        }
      },
      error: (error: any) => {
        console.log(error)
      }
    })
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    const hasSearch = this.searchQuery && this.searchQuery.trim().length > 0;
    const obs = hasSearch
      ? this.userManagementService.getUserListBySearchQueryPaginated(this.searchQuery, this.pageIndex + 1, this.pageSize, this.statusFilter)
      : this.userManagementService.getUserListPaginated(this.pageIndex + 1, this.pageSize, this.statusFilter);
    obs.subscribe((res: any) => {
      if (res.isSuccess) {
        this.dataSource.data = res.items;
        this.userList = res.items;
        this.totalRecords = (res.totalRecords ?? res.total ?? res.count ?? (res.items?.length || 0));
        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }
      }
    });
  }

  openAddModel() {
    const dialogRef = this.dialog.open(PropertyAddComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  viewDetail(detail: any) {
    const dialogRef = this.dialog.open(PropertyDetailComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  openUploadedVideos(detail: any) {
    this.dialog.open(UserVideosDialogComponent, {
      width: '70%',
      maxWidth: '900px',
      panelClass: 'responsive-dialog',
      data: {
        user: detail,
        videos: detail?.uploadedVideos || []
      }
    });
  }

  edit(data: any, panel: any) {
    const dialogRef = this.dialog.open(PropertyAddComponent, {
      // maxWidth: '100vw',
      // maxHeight: '100vh',
      // height: '70%',
      width: '60%',
      panelClass: 'responsive-dialog',
      data: {
        panel
        // requestedProfile
      },

    }).afterClosed().subscribe((data: any) => {
      console.log('data', data)
      if (data == true) { }
    })
  }

  deleteItem(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '250px',
      panelClass: 'confirm-dialog',
      position: {
        top: '10px', // Align to the top
        // left: '40%', // Center horizontally
      },
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          yes: 'yes',
          no: 'no'
        }
      },
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.userManagementService.deleteUserById(data.user.id).subscribe({
          next: (res: any) => {
            if (res.isSuccess) {
              this.toastService.successToast('User deleted successfully');
              this.getUserList();
            }
          },
          error: (error: any) => {
            console.error('Delete error:', error);
            this.toastService.errorToast('Failed to delete user');
          }
        });
      }
    });
  }


  onActionSelect(event: any) { }

  onAction1(element: any) { }
}
